import makeResourceAutocompleteFilter from "../components/makeResourceAutocompleteFilter";

const filterBrands = makeResourceAutocompleteFilter({
  name: "brands",
  resource: "brands",
  titleSingular: "Brand",
  titlePlural: "Brands",
  skipsPagination: true,
});

export default filterBrands;
